import { render, staticRenderFns } from "./Headsup.vue?vue&type=template&id=188fe2da&scoped=true&"
import script from "./Headsup.vue?vue&type=script&lang=js&"
export * from "./Headsup.vue?vue&type=script&lang=js&"
import style0 from "./Headsup.vue?vue&type=style&index=0&id=188fe2da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188fe2da",
  null
  
)

export default component.exports